import { ThemeContext } from 'grommet/contexts/ThemeContext';
import React from 'react';
export var useTheme = function () {
    return React.useContext(ThemeContext);
};
